import { X, Share, Plus, Home } from 'lucide-react';
import { useState, useEffect } from 'react';

export function IOSInstallPrompt() {
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Detect iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
    
    // Check if already running as standalone app
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;
    
    // Check if previously dismissed
    const dismissed = localStorage.getItem('ios-install-dismissed') === 'true';

    setIsIOS(isIOSDevice);
    setIsStandalone(isInStandaloneMode);
    setIsDismissed(dismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('ios-install-dismissed', 'true');
    setIsDismissed(true);
  };

  // Don't show if not iOS, already installed, or dismissed
  if (!isIOS || isStandalone || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-fade-in">
      <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-200">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center">
              <Home className="w-4 h-4 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900">Install Fittory</h3>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-3">
          Install this app on your home screen for quick access!
        </p>

        <div className="space-y-2 text-sm">
          <div className="flex items-start gap-2">
            <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-blue-600">1</span>
            </div>
            <div className="flex items-center gap-1 text-gray-700">
              <span>Tap the</span>
              <Share className="w-4 h-4 text-blue-500 inline" />
              <span className="font-medium">Share</span>
              <span>button below</span>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-blue-600">2</span>
            </div>
            <div className="flex items-center gap-1 text-gray-700">
              <span>Scroll and tap</span>
              <Plus className="w-4 h-4 text-gray-600 inline" />
              <span className="font-medium">Add to Home Screen</span>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-blue-600">3</span>
            </div>
            <div className="text-gray-700">
              <span>Tap</span>
              <span className="font-medium ml-1">Add</span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
